import { put, call, takeLatest } from 'redux-saga/effects'

import { getEntityTags as getEntityTagsApi } from 'Service/Api'

import * as EntityTypes from 'Redux/Types/EntityTypes'
import * as EntityActions from 'Redux/Actions/EntityActions'

function* getExpenseEntityTags({ payload }) {
  try {
    const { data } = yield call(getEntityTagsApi, payload)
    yield put(EntityActions.fetchExpenseEntityTagsSucceeded(data))
  } catch (errors) {
    yield put(EntityActions.fetchExpenseEntityTagsFailed(errors))
  }
}

export default function* GLCodeSaga() {
  yield takeLatest(EntityTypes.FETCH_EXPENSE_ENTITY_TAGS, getExpenseEntityTags)
}
